import { DateFormat } from './types';

export const parseDate = (
  dateString: string,
  format: DateFormat = DateFormat.ISO,
): Date | null => {
  if (!dateString || typeof dateString !== 'string') {
    return null;
  }
  const delimiter = /[^\w]/; // non-alphanumeric chars
  let year = 2024; // default to a leap year;
  let month = 1;
  let day = 1;
  const dateParts = dateString.split(delimiter);
  const formatParts = format.split(delimiter);
  formatParts.forEach((part, i) => {
    if (part === 'MM') {
      month = +dateParts[i];
    } else if (part === 'yyyy') {
      year = +dateParts[i];
    } else if (part === 'dd') {
      day = +dateParts[i];
    }
  });
  if (
    isNaN(year) ||
    isNaN(month) ||
    isNaN(day) ||
    month < 1 ||
    month > 12 ||
    year < 1000 ||
    year > 9999 ||
    day < 1
  ) {
    return null;
  }
  const daysInMonth = new Date(year, month, 0).getDate();
  if (daysInMonth < day) {
    return null;
  }
  const date = new Date(Date.UTC(year, month - 1, day));
  if (isNaN(date.getTime())) {
    return null;
  }

  return date;
};
